module.exports = __webpack_public_path__ + "static/media/module-shop.7ed286e4.png";